import { createSlice } from '@reduxjs/toolkit';

import { setUser } from './actions';
import { initialState } from './state';

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setUser, (state, { payload }) => {
      state.user = payload;
    });
  },
});
